if (!customElements.get('discount-best-sellers')) {
  class DiscountBestSellers extends HTMLElement {
    connectedCallback() {
      if (this.dataset.randomized === 'true') return;

      const grid = this.querySelector('[data-discount-grid]');
      if (!grid) return;

      const cards = Array.from(grid.children);
      for (let index = cards.length - 1; index > 0; index -= 1) {
        const randomIndex = Math.floor(Math.random() * (index + 1));
        [cards[index], cards[randomIndex]] = [cards[randomIndex], cards[index]];
      }

      const fragment = document.createDocumentFragment();
      cards.forEach((card) => fragment.appendChild(card));
      grid.appendChild(fragment);
      this.dataset.randomized = 'true';
    }
  }

  customElements.define('discount-best-sellers', DiscountBestSellers);
}
